import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePOST, securePUT, secureDELETE } from '../utilities/FetchHelper';

class MasterBoxConfigurationService {

    getMasterBoxes() {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_MASTER_BOX_GET

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    addMasterBox(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_MASTER_BOX_POST

        return fetchJSON(url, { ...securePOST(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    updateMasterBox(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_MASTER_BOX_PUT_DELETE
        url = url.replace('{boxName}', data.boxName)
        
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    deleteMasterBox(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_CONFIGURE_MASTER_BOX_PUT_DELETE
        url = url.replace('{boxName}', data.boxName)
        
        return fetchJSON(url, { ...secureDELETE(true), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new MasterBoxConfigurationService()